<script setup>
import {reactive, onMounted, computed} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'BatchesComponent';


const data = reactive({
  dataLoading: true,
  selectedBatch: null,
  headers: [
    { title: 'Invoice Number', key: 'invoiceid' },
    { title: 'Invoice Date', key: 'invoicedateformatted' },
    { title: 'Payment Amount', key: 'amount' },
    { title: 'Payment Date', key: 'dateformatted' },
    { title: 'Actions', key: 'actions' }
  ],
  items: [],
  batches: [],
})

const csvData = computed(()=>{
  // CSV File
  return data.items.map((item) => ({
    ...item,
    name: item.name,
    invoiceid: item.invoiceid,
    invoicedate: item.invoicedate,
    amount: item.amount,
    date: item.date,
    actions: item.actions,
  }));
})

const csvExport = (arrData) => {
  // CSV File
  let csvContent = 'data:text/csv;charset=utf-8,';
  csvContent += [
    Object.keys(arrData[0]).join(','),
    ...arrData.map((item) => Object.values(item).join(',')),
  ]
      .join('\n')
      .replace(/(^\[)|(\]$)/gm, '');

  const csvData = encodeURI(csvContent).replaceAll('#', '%23');
  const link = document.createElement('a');
  link.setAttribute('href', csvData);
  link.setAttribute('download', 'export.csv');
  link.click();
}

const submit = () => {
}

const getData = () => {
  ApiWrapper.get('payments', 'get-batches','contextId=null')
      .then((response) => {
        let batchRes = response.rows;
        data.batches = [];
        for (let batch in batchRes) {
          data.batches.push(batchRes[batch].title);
        }
        data.dataLoading = false;
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.dataLoading = false;
      })
}

const getBatchData = (batch) => {
  data.dataLoading = true;
  ApiWrapper.post('payments', 'get-batch-data', {
        batchName: batch,
      })
      .then((response) => {
        data.items = response.batchData;
        getData();
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.dataLoading = false;
      })
}

const editItem = (item) => {
  //TODO
}

const deleteItem = (item) => {
  //TODO
}

onMounted(()=>{
  getData();
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>Payments Per Batch</v-toolbar-title>
        <!-- <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="primary"
        ></v-progress-linear> -->
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-icon @click="csvExport(csvData)" v-if="data.items.length"> mdi-file-download </v-icon>

        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-actions>
        <v-row>
          <v-col cols="12" sm="4" v-if="Permissions.checkPermissions(['payments.read-batch'])">
            <v-select
                @update:modelValue="getBatchData($event)"
                v-model="data.selectedBatch"
                :items="data.batches"
                class="pa-2"
                label="Select Batch"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-actions>

      <v-data-table
          :headers="data.headers"
          :items="data.items"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.amount`]="{ item }">
          <span>{{ item.amountformatted }}</span>
        </template>
        <!--
        TODO: These buttons currently do nothing so commenting them out, should they have edit and delete functionality?
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-if="Permissions.checkPermissions(['payments.update'])" @click="editItem(item)"> mdi-pencil </v-icon>
          <v-icon v-if="Permissions.checkPermissions(['payments.delete'])" @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        -->
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>